import { createSlice } from "@reduxjs/toolkit";
import { getAreaList, getAreaByID, addArea, getlotByCompLocWarhouse,getlotByLocWarhouse,getlotByWarhouse } from "./AreaAction";

const areaSlice = createSlice({
    name: "area",
    initialState: {
        error: "Sorry! No Data Found.",
        message: null,
        loading: false,
        unitsLoading: false,
        model: false,
        error_msg: null,
        rowdata: {},
        listCount: 0,
        lotlist: [],
        locWarehouseList: [],
        lotParams: {
            no_of_pages: 0,
            page_size: 10,
            page: 1,
            search: "",
            currentSort: "code",
            sortOrder: "-",
        },
        lotByCompLocWarehouse: [],
        lotByLocWarehouse: [],
        lotByWarehouse: [],
    },
    reducers: {

        InputChangeValue: (state, action) => {
            return {
                ...state,
                rowdata: {
                    ...state.rowdata,
                    [action.payload.key]: action.payload.value,
                },
            };
        },
        SetLotParams: (state, action) => {
            return {
                ...state,
                lotParams: {
                    ...state.lotParams,
                    ...action.payload
                },
            };
        },
        setLocWarehouseList: (state, action) => {
            return {
                ...state,
                locWarehouseList: action.payload,
            };
        },
        isModelVisible: (state, action) => {
            if (!action.payload) {
                return {
                    ...state,
                    model: action.payload,
                    rowdata: {},
                };
            } else {
                return {
                    ...state,
                    model: action.payload,
                };
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAreaList.pending, (state, action) => {
                state.status = "getAreaList loading";
                state.loading = true;
            })
            .addCase(getAreaList.fulfilled, (state, action) => {
                state.status = "getAreaList succeeded";
                state.loading = false;
                var response = action.payload.response;
                var noofpages = Math.ceil(
                    action.payload.count / state.lotParams?.page_size
                );

                state.lotlist = response.results;
                state.listCount = response.count;
                state.lotParams = {
                    ...state.lotParams,
                    no_of_pages: noofpages,
                };
            })
            .addCase(getAreaList.rejected, (state, action) => {
                state.status = "getAreaList failed";
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(getAreaByID.pending, (state, action) => {
                state.status = "getAreaByID loading";
                state.loading = true;
            })
            .addCase(getAreaByID.fulfilled, (state, action) => {
                state.status = "getAreaByID succeeded";
                state.loading = false
                state.rowdata = action.payload;
            }
            )
            .addCase(getAreaByID.rejected, (state, action) => {
                state.status = "getAreaByID failed";
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(addArea.pending, (state, action) => {
                state.status = "addArea loading";
                state.loading = true;
            })
            .addCase(addArea.fulfilled, (state, action) => {
                state.status = "addArea succeeded";
                state.loading = false
                state.model = action.payload.modal;
                state.message = action.payload.response;
                state.rowdata = {};
            }
            )
            .addCase(addArea.rejected, (state, action) => {
                state.status = "addArea failed";
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(getlotByCompLocWarhouse.pending, (state, action) => {
                state.status = "getlotByCompLocWarhouse loading";
                state.loading = true;
            })
            .addCase(getlotByCompLocWarhouse.fulfilled, (state, action) => {
                state.status = "getlotByCompLocWarhouse succeeded";
                state.loading = false
                state.lotByCompLocWarehouse = action.payload.results;
            }
            )
            .addCase(getlotByCompLocWarhouse.rejected, (state, action) => {
                state.status = "getlotByCompLocWarhouse failed";
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(getlotByLocWarhouse.pending, (state, action) => {
                state.status = "getlotByLocWarhouse loading";
                state.loading = true;
            })
            .addCase(getlotByLocWarhouse.fulfilled, (state, action) => {
                state.status = "getlotByLocWarhouse succeeded";
                state.loading = false
                state.lotByLocWarehouse = action.payload.results;
            }
            )
            .addCase(getlotByLocWarhouse.rejected, (state, action) => {
                state.status = "getlotByLocWarhouse failed";
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(getlotByWarhouse.pending, (state, action) => {
                state.status = "getlotByWarhouse loading";
                state.loading = true;
            })
            .addCase(getlotByWarhouse.fulfilled, (state, action) => {
                state.status = "getlotByWarhouse succeeded";
                state.loading = false
                state.lotByWarehouse = action.payload.results;
            }
            )
            .addCase(getlotByWarhouse.rejected, (state, action) => {
                state.status = "getlotByWarhouse failed";
                state.loading = false;
                state.error = action.error.message;
            })
    }

});
export const {
    InputChangeValue,
    SetLotParams,
    isModelVisible,
    setLocWarehouseList,
} = areaSlice.actions;

export default areaSlice.reducer;